import { createSelector } from '@ngrx/store';
import { consoleFeature } from './console.feature';

export const selectSelectedTenant = createSelector(
  consoleFeature.selectConsoleState,
  (state) => state.selectedTenant,
);

export const selectSelectedSubscription = createSelector(
  consoleFeature.selectConsoleState,
  (state) => state.selectedSubscription,
);
